<template>
  <div class="app-container">
    <div class="cost-breakdown-body">
      <!-- 查询条件 -->
      <div ref="searchBox" class="formBox margbot" style="padding-bottom: 10px;">
        <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="100px" size="mini" style="width: 100%;">
          <el-form-item label="客户名称:">
             <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择" filterable clearable>
              <el-option
                v-for="(item,index) in keHuOptions"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[0]" btnCode="003P01iB001">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[1]" btnCode="003P01iB002">重置</el-button>
            <el-button type="primary" size="mini" @click="tianjia" v-if="btnFlg[2]" btnCode="003P01iB003">添加账户</el-button>
            <el-button type="primary" size="mini" @click="shanchu" v-if="btnFlg[3]" btnCode="003P01iB004">删除账户</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格 -->
      <div :style="{ height: h }">
        <el-table
          height="100%"
          size="mini"
          border
          center
          bordersize="mini"
          ref="tabref1"
          :data="tableData"
          style="width: 100%"
          class="tableComent"
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
          highlight-current-row
          @row-click="dianjixuanzhong"
      >
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="prestore(scope.row)">预存</el-button>
            <el-button type="text" size="small" @click="refund(scope.row)">退款</el-button>
            <el-button type="text" size="small" @click="detail(scope.row)">交易明细</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="账户名称" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeBalance" label="预存款余额" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.feeBalance==null">0</span>
            <span v-else>{{scope.row.feeBalance}}</span>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <div class="pags" style="text-align: right">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="pageInfo.pageNo"
          :page-size="pageInfo.pageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 添加 -->
    <div>
      <el-dialog
        title="添加"
        :visible.sync="XZvisible"
        :close-on-click-modal="false"
        @close="XZvisible=false"
        width="40%"
        center
      >
        <el-form
          :model="XZFormData"
          ref="XZFormData"
          label-width="150px"
          class="demo-dynamic"
          style="width:350px;margin:30px auto;"
        >
          <el-form-item prop="customerTaxId" label="客户名称：" :rules="[{required:true,message:'请选择客户名称',trigger:'change'}]">
            <el-select v-model="XZFormData.customerTaxId" size="mini" placeholder="请选择" filterable clearable>
              <el-option
                v-for="(item,index) in keHuOptions"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="width:180px;margin:15px auto;">
          <el-button @click="XZvisible = false">取 消</el-button>
          <el-button type="primary" @click="xzQD()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 预存或退款 -->
    <div>
      <el-dialog
        :title="title"
        v-if="YTvisible"
        :visible.sync="YTvisible"
        :close-on-click-modal="false"
        @close="YTvisible=false"
        width="40%"
        center

      >
        <el-form :model="YTFormData" :rules="Rules" ref="YTFormData" label-width="150px" style="width:350px;margin:0px auto;">
          <el-form-item prop="customerName" label="账户名称：">{{ ZHname }}</el-form-item>
          <el-form-item prop="feeBalance" label="余额：">
            <span style="color:red">{{ YTFormData.feeBalance }}</span> 元
          </el-form-item>
          <el-form-item v-if="title=='预存'" prop="transactionAmount" label="预存金额：">
            <el-input size="mini" v-model="YTFormData.transactionAmount" style="width:193px;" v-number-input.float="2"><template slot="suffix">元</template></el-input>
          </el-form-item>
          <el-form-item v-else prop="transactionAmount" label="退款金额：">
            <el-input size="mini" v-model="YTFormData.transactionAmount" style="width:193px;" v-number-input.float="2"><template slot="suffix">元</template></el-input>
          </el-form-item>
        </el-form>
        <div style="width:180px;margin:15px auto;">
          <el-button @click="YTvisible = false">取 消</el-button>
          <el-button type="primary" @click="YTQD" :loading="addLoad">提 交</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 交易明细 -->
    <div>
      <el-dialog
        title="交易明细"
        :visible.sync="JYvisible"
        :close-on-click-modal="false"
        @close="JYvisible=false"
        width="80%"
        center
      >
        <el-form :inline="true" :model="JYFormData" ref="JYFormData" class="demo-dynamic">
          <el-form-item prop="customerName" label="账户：">{{ ZHname }}</el-form-item>
          <el-form-item prop="feeBalance" label="预付款余额：">
            <span style="color:red">{{ money }}</span> 元
          </el-form-item>
          <br/>
          <el-form-item prop="time" label="交易时间：">
            <el-date-picker
              v-model="JYFormData.transactionTimeStart"
              size="mini"
              type="datetime"
              placeholder="选择交易时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            -
            <el-date-picker
              v-model="JYFormData.transactionTimeEnd"
              size="mini"
              placeholder="选择交易时间"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="交易类型：" prop="feeType">
            <el-select v-model="JYFormData.feeType" size="mini" placeholder="请选择" filterable clearable>
              <el-option
                v-for="(item,id) in JYtype"
                :key="id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="JYchaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="JYchongzhi">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="height:300px">
          <el-table
            height="100%"
            size="mini"
            border
            center
            bordersize="mini"
            ref="tableDataJY"
            :data="tableDataJY"
            style="width: 100%"
            class="elTab"
            :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        >
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="transactionNo" label="交易编号" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeTypeName" label="交易类型" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="transactionAmount" label="交易金额" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.feeType  == 1 || scope.row.feeType  == 4" style="color:#118a04">+{{scope.row.transactionAmount}}</span>
              <span v-else style="color:#e60c0c">-{{scope.row.transactionAmount}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeBalance" label="账户余额" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="transactionTime" label="交易时间" align="center" :formatter="dateTimeFormat" width="180"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="businessNo" label="业务单号" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="operationUser" label="操作人" align="center" width="120"></el-table-column>
          </el-table>
        </div>
        <div class="pags" style="text-align: right">
          <el-pagination
            background
            @current-change="handleCurrentChangeJY"
            :current-page="pageInfoJY.pageNo"
            :page-size="pageInfoJY.pageSize"
            :page-sizes="[10, 20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChangeJY"
            :total="totalJY"
          ></el-pagination>
        </div>
        <div style="width:100px;margin:15px auto;">
          <el-button @click="JYvisible = false">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getTPerFeeList, // 列表查询
  getRelationCustomer, // 客户名称
  addTPerFee, // 添加
  DelTPerFee, // 删除
  addPrestoreOrRefund, // 预存或退款
  getDPreFeeList // 明细查询
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { dateTimeFormat } from '@/utils/util'
import { getBtn } from '@/utils/getButton'

export default {
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      formData: {
        customerTaxId: ''
      },
      keHuOptions: [],
      // 分页
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      // 表格
      tableData: [],
      h: '500px',
      xuanzhongArr: null,
      // 添加
      XZvisible: false,
      XZFormData: {
        customerTaxId: ''
      },
      addLoad: false,
      // 预存或退款
      title: '',
      YTvisible: false,
      YTFormData: {
        ZHname: '',
        feeBalance: 0,
        transactionAmount: ''
      },
      Rules: {
        transactionAmount: [
          { required: true, message: '请填写金额', trigger: 'blur' }
        ]
        // TKmoney: [
        //   { required: true, message: '请填写预存金额', trigger: 'blur' }
        // ]
      },
      money: 0,
      ZHname: '',
      // 交易明细
      JYvisible: false,
      JYFormData: {
        transactionTimeStart: new Date().getTime() - 3600 * 1000 * 24 * 30,
        transactionTimeEnd: new Date().getTime(),
        feeType: ''
      },
      tableDataJY: [],
      totalJY: 0,
      pageInfoJY: {
        pageNo: 1,
        pageSize: 20
      },
      JYtype: [
        {
          id: 1,
          name: '预存'
        },
        {
          id: 2,
          name: '退款'
        },
        {
          id: 3,
          name: '仓储结算'
        },
        {
          id: 4,
          name: '退货退款'
        }
      ],
      preFeeMasterId: '',
      btnFlg: [],
      btnIdArr: ['003P01iB001', '003P01iB002', '003P01iB003', '003P01iB004']
    }
  },
  methods: {
    chaxun () {
      getTPerFeeList(
        {
          ...this.formData,
          ...this.pageInfo
        }
      )
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.xuanzhongArr = null
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chongzhi () {
      this.formData = { customerNameTaxId: '' }
      this.chaxun()
    },
    tianjia () {
      this.XZvisible = true
      if (this.$refs.XZFormData !== undefined) {
        this.$refs.XZFormData.resetFields()
      }
      this.addLoad = false
    },
    shanchu () {
      if (this.xuanzhongArr == null) {
        this.$message.error('请先选中一条数据')
      } else if (this.xuanzhongArr.feeBalance > 0) {
        this.$message.error('账户有余额，不可删除')
      } else {
        this.$confirm('删除后数据不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {
          console.log(res)
          DelTPerFee(
            {
              preFeeMasterId: this.xuanzhongArr.preFeeMasterId
            }
          ).then(res => {
            console.log(res)
            this.chaxun()
          })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
          .catch(() => {
            // this.$message({ message: error.message, type: 'error' })
          })
      }
    },
    // 预存
    prestore (row) {
      if (this.$refs.YTFormData !== undefined) {
        this.$refs.YTFormData.resetFields()
      }
      console.log(row)
      this.title = '预存'
      this.ZHname = row.customerName
      this.YTFormData.feeBalance = row.feeBalance == null ? 0 : row.feeBalance
      this.addLoad = false
      this.YTFormData.transactionAmount = ''
      this.YTvisible = true
    },
    YTQD () {
      this.$refs.YTFormData.validate(valid => {
        if (valid) {
          this.addLoad = true
          if (this.title == '退款' && this.YTFormData.transactionAmount > this.YTFormData.feeBalance) {
            this.$message.error('退款金额不可大于余额')
            this.addLoad = false
          } else if (this.YTFormData.transactionAmount == 0) {
            this.$message.error('金额不能为0')
            this.addLoad = false
          } else {
            addPrestoreOrRefund(
              {
                preFeeMasterId: this.xuanzhongArr.preFeeMasterId,
                transactionAmount: this.YTFormData.transactionAmount,
                flag: this.title == '预存' ? 1 : 2
              }
            )
              .then(res => {
                console.log(res)
                this.YTvisible = false
                this.addLoad = false
                this.chaxun()
              })
              .catch(error => {
                // DonMessage.error(error.message)
                this.$message({ message: error.message, type: 'error' })
                this.addLoad = false
              })
          }
        } else {
          this.addLoad = false
        }
      })
    },
    // 退款
    refund (row) {
      if (this.$refs.YTFormData !== undefined) {
        this.$refs.YTFormData.resetFields()
      }
      if (row.feeBalance == 0) {
        this.$message.error('该用户金额为0')
      } else {
        this.YTvisible = true
        this.title = '退款'
        this.ZHname = row.customerName
        this.YTFormData.feeBalance = row.feeBalance == null ? 0 : row.feeBalance
        this.addLoad = false
        this.YTFormData.transactionAmount = ''
      }
    },
    // 交易明细
    detail (row) {
      this.JYvisible = true
      this.ZHname = row.customerName
      this.money = row.feeBalance
      this.JYFormData = {
        transactionTimeStart: '',
        transactionTimeEnd: '',
        feeType: ''
      }
      this.preFeeMasterId = row.preFeeMasterId
      this.JYchaxun()
    },
    // 交易查询
    JYchaxun () {
      getDPreFeeList(
        {
          preFeeMasterId: this.preFeeMasterId,
          ...this.JYFormData,
          ...this.pageInfoJY
        }
      )
        .then(res => {
          console.log(res)
          this.tableDataJY = res.list
          this.totalJY = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 交易重置
    JYchongzhi () {
      this.JYFormData = {}
      this.JYchaxun()
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    // 获取所属客户数据
    getRelationCustomer () {
      getRelationCustomer().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        this.$message({ message: err.message, type: 'error' })
      })
    },
    xzQD () {
      let customerName = this.keHuOptions.filter(item => item.taxpayerNumber == this.XZFormData.customerTaxId)[0].custerName
      this.$refs.XZFormData.validate(valid => {
        if (valid) {
          this.addLoad = true
          addTPerFee(
            {
              ...this.XZFormData,
              customerName
            }
          ).then(res => {
            console.log(res)
            this.XZvisible = false
            this.chaxun()
          })
            .catch(error => {
              DonMessage.error(error.message)
              this.addLoad = false
            })
        } else {
          this.addLoad = false
        }
      })
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    handleCurrentChangeJY (val) {
      this.pageInfoJY.pageNo = val
      this.JYchaxun()
    },
    handleSizeChangeJY (val) {
      this.pageInfoJY.pageSize = val
      this.JYchaxun()
    }
  },
  created () {
    this.chaxun()
    this.btnFlg = getBtn(this.btnIdArr, '/prestore')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
    this.getRelationCustomer()
  }
}
</script>

<style lang="less" scoped>

</style>
